export const filterSortAndPaginateOperators = (
  operators,
  search_text,
  teamGrades = null,
  individualGrades = null,
  sortDescriptor,
  nbOperatorsPerPage,
  pageNumber,
  departmentId = "all"
) => {
  if (!operators || operators.length === 0) return [];

  let filtered_operators = operators;

  // Applying filters
  if (departmentId && departmentId !== "all") {
    filtered_operators = filtered_operators.filter(
      (operator) => operator?.department_id === departmentId
    );
  }

  if (search_text !== "") {
    filtered_operators = filtered_operators.filter((operator) => {
      // Check each specified field against the provided criteria
      const matches_operator_name = operator?.operator_name
        ?.toLowerCase()
        ?.includes(search_text.toLowerCase());
      const matches_team = operator?.team?.toLowerCase()?.includes(search_text.toLowerCase());
      const matches_team_grade = operator?.team_grade?.toString().includes(search_text);
      const matches_individual_grade = operator?.average_grade?.toString().includes(search_text);
      const matches_department = operator?.department
        ?.toLowerCase()
        .includes(search_text.toLowerCase());

      // Return true if any specified fields match the criteria
      return (
        matches_operator_name ||
        matches_team ||
        matches_team_grade ||
        matches_individual_grade ||
        matches_department
      );
    });
  }

  const hasIndividualGrades =
    individualGrades?.min_individual_grade > 0 || individualGrades?.max_individual_grade < 10;
  const hasTeamGrades = teamGrades?.min_team_grade > 0 || teamGrades?.max_team_grade < 10;

  if (hasIndividualGrades) {
    filtered_operators = filtered_operators.filter(
      (operator) =>
        operator.average_grade >= individualGrades?.min_individual_grade &&
        operator.average_grade <= individualGrades?.max_individual_grade
    );
  }
  if (hasTeamGrades) {
    filtered_operators = filtered_operators.filter(
      (operator) =>
        operator.team_grade >= teamGrades?.min_team_grade &&
        operator.team_grade <= teamGrades?.max_team_grade
    );
  }

  // Sorting
  const getSortFunction = (sortDescriptor) => {
    const { direction: sortDirection, sortBy: sortColumn } = sortDescriptor;
    const isReverted = sortDirection === "asc";

    const defaultStringSort = (a, b) => {
      const cellValueA = a[sortColumn] || "";
      const cellValueB = b[sortColumn] || "";
      const cmp = cellValueA.localeCompare(cellValueB);
      return isReverted ? -cmp : cmp;
    };

    const defaultNumberSort = (a, b) => {
      const cellValueA = a[sortColumn] || 0;
      const cellValueB = b[sortColumn] || 0;
      const cmp = cellValueB - cellValueA;

      return isReverted ? -cmp : cmp;
    };

    const sortFunctionsMapByColumnName = {
      operator_name: defaultStringSort,
      team: defaultStringSort,
      department: defaultStringSort,
      nb_calls: defaultNumberSort,
      nb_incoming: defaultNumberSort,
      nb_outgoing: defaultNumberSort,
      nb_frustrated: defaultNumberSort,
      nb_frustrated_calls: defaultNumberSort,
      team_grade: (a, b) => {
        const gradeA = a.team_grade || 0;
        const gradeB = b.team_grade || 0;

        const cmp = gradeA < gradeB ? -1 : gradeA > gradeB ? 1 : 0;
        return isReverted ? -cmp : cmp;
      },
      grade: (a, b) => {
        const gradeA = a.average_grade || 0;
        const gradeB = b.average_grade || 0;

        const cmp = gradeA < gradeB ? -1 : gradeA > gradeB ? 1 : 0;
        return isReverted ? -cmp : cmp;
      },
    };
    return sortFunctionsMapByColumnName[sortColumn];
  };

  const compareFunction = getSortFunction(sortDescriptor);
  filtered_operators.sort(compareFunction);
  const nbFiltered = filtered_operators.length;

  // Applying pagination
  const paginationStart = pageNumber * nbOperatorsPerPage;
  const paginationEnd = (pageNumber + 1) * nbOperatorsPerPage;
  const result = filtered_operators.slice(paginationStart, paginationEnd);

  return {
    operators: result,
    nbFiltered,
  };
};

export const filterSortAndPaginateFinancialDetails = (
  operators,
  search_text,
  sortDescriptor,
  nbOperatorsPerPage,
  pageNumber
) => {
  if (!operators || operators.length === 0) return [];

  let filtered_operators = operators;

  // Applying filters
  if (search_text !== "") {
    filtered_operators = filtered_operators.filter((operator) => {
      // Check each specified field against the provided criteria
      const matches_operator_name = operator?.name
        ?.toLowerCase()
        ?.includes(search_text.toLowerCase());
      const matches_team = operator?.team?.toLowerCase()?.includes(search_text.toLowerCase());
      const matches_individual_grade = operator?.average_grade?.toString().includes(search_text);
      const matches_department = operator?.department
        ?.toLowerCase()
        .includes(search_text.toLowerCase());

      // Return true if any specified fields match the criteria
      return (
        matches_operator_name || matches_team || matches_individual_grade || matches_department
      );
    });
  }

  // Sorting
  const getSortFunction = (sortDescriptor) => {
    const { direction: sortDirection, sortBy: sortColumn } = sortDescriptor;
    const isReverted = sortDirection === "asc";

    const defaultStringSort = (a, b) => {
      const cellValueA = a[sortColumn] || "";
      const cellValueB = b[sortColumn] || "";
      const cmp = cellValueA.localeCompare(cellValueB);
      return isReverted ? -cmp : cmp;
    };

    const defaultNumberSort = (a, b) => {
      const cellValueA = a[sortColumn] || 0;
      const cellValueB = b[sortColumn] || 0;
      const cmp = cellValueB - cellValueA;

      return isReverted ? -cmp : cmp;
    };

    const sortFunctionsMapByColumnName = {
      name: defaultStringSort,
      team: defaultStringSort,
      department: defaultStringSort,
      revenue: defaultNumberSort,
    };
    return sortFunctionsMapByColumnName[sortColumn];
  };

  const compareFunction = getSortFunction(sortDescriptor);
  filtered_operators.sort(compareFunction);
  const nbFiltered = filtered_operators.length;

  // Applying pagination
  console.log({ pageNumber, nbOperatorsPerPage, filtered_operators });
  const paginationStart = pageNumber * nbOperatorsPerPage;
  const paginationEnd = (pageNumber + 1) * nbOperatorsPerPage;
  const result = filtered_operators.slice(paginationStart, paginationEnd);
  console.log({ result });

  return {
    operators: result,
    nbFiltered,
  };
};
